// Viewport
export const SET_VIEWPORT = 'SET_VIEWPORT';
export const SET_PAGE_VISIBILITY = 'SET_PAGE_VISIBILITY';

// Scroll
export const SET_SCROLL = 'SET_SCROLL';
export const DISABLE_SCROLL = 'DISABLE_SCROLL';

// Page
export const SET_PAGE_LOADING = 'SET_PAGE_LOADING';

// Side panel
export const SET_SIDE_PANEL = 'SET_SIDE_PANEL';

// Animation hooks
export const ACTIVATE_HOOK = 'ACTIVATE_HOOK';
export const UPDATE_HOOK = 'UPDATE_HOOK';
export const REGISTER_HOOK = 'REGISTER_HOOK';
export const DEACTIVATE_HOOK = 'DEACTIVATE_HOOK';

// Destkop menu shadow
export const SET_DESKTOP_MENU_SHADOW = 'SET_DESKTOP_MENU_SHADOW';
export const SET_DESKTOP_MENU_OPEN_STATE = 'SET_DESKTOP_MENU_OPEN_STATE';

// Header Search
export const SET_HEADER_SEARCH_VISIBILITY = 'SET_HEADER_SEARCH_VISIBILITY';

// Easter Egg
export const ENABLE_EGG = 'ENABLE_EGG';

// Collection points
export const SET_API_ENDPOINTS = 'SET_API_ENDPOINTS';
export const SET_CANTON_DETAIL_SEARCH_VALUE = 'SET_CANTON_DETAIL_SEARCH_VALUE';
export const SET_ENTRIES = 'SET_ENTRIES';
export const SET_SEARCH_LOCATION = 'SET_SEARCH_LOCATION';
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
export const SET_SEARCH_RESULTS_LOADING_STATE = 'SET_SEARCH_RESULTS_LOADING_STATE';
